// Canvas-local avatar URL helpers. Intranet has a richer version in
// `peopleUtils.js` that looks the person up in `root.people` first — on
// canvas there's no `people` table, so we just return a deterministic
// dicebear initials SVG seeded by the email (or any string). Same service
// intranet ultimately falls back to, so avatars look identical across
// apps when the person isn't in governance's directory.

const DICEBEAR = 'https://api.dicebear.com/7.x/initials/svg?seed='

export const avatarUrl = (seed) =>
  `${DICEBEAR}${encodeURIComponent(seed || '?')}`

// Same `(root, email)` / `(email)` call shapes as intranet's version so
// shared components (`AppHeader.Me`, `OrgMemberRow.Avatar`) bind the same
// way regardless of which app they render in.
export function avatarUrlFor (root, email) {
  let e = email
  if (typeof root === 'string' && email === undefined) e = root
  return avatarUrl(e)
}
